"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVariableAprAnnotation = exports.getFixedAprAnnotation = exports.getOfferType = exports.getSubProductType = exports.getStarRatingTooltip = exports.getStarRating = exports.getSlug = exports.getQualificationsBullets = exports.getProsBullets = exports.getName = exports.getMinVariableAPR = exports.getMinFixedAPR = exports.getMinFICO = exports.getMaxVariableAPR = exports.getMaxFixedAPR = exports.getLearnMoreLink = exports.getIssuerName = exports.getImageSrc = exports.getImageAltText = exports.getDisclaimer = exports.getConsBullets = exports.getBottomLine = exports.getAvailableTermLengths = void 0;

var _get2 = _interopRequireDefault(require("lodash/get"));

var _generalUtils = require("./common/general-utils");

var _utils = require("../utils");

/**
 * Gets available term lengths
 *
 * @param  {Object} marketplaceEntity The marketplace entity
 *
 * @return {String} The available term lengths.
 */
var getAvailableTermLengths = function getAvailableTermLengths(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.available_term_lengths.value');
};
/**
 * Get the bottom line text.
 *
 * @param  {Object} marketplaceEntity   The marketplace entity
 * @return {String}                     The bottom line value.
 */


exports.getAvailableTermLengths = getAvailableTermLengths;

var getBottomLine = function getBottomLine(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.tagline.value');
};
/**
 * Gets the "cons" bullets
 *
 * @param  {Object} marketplaceEntity The marketplace entity
 *
 * @return {Array}  The "cons" array
 */


exports.getBottomLine = getBottomLine;

var getConsBullets = function getConsBullets(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.cons_bullets.value');
};
/**
 * Get the disclaimer.
 *
 * @param {Object} marketplaceEntity The education loans entity.
 *
 * @return {string} The disclaimer.
 */


exports.getConsBullets = getConsBullets;

var getDisclaimer = function getDisclaimer(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.disclaimer.value');
};
/**
 * Gets the name of the entity as the alt text for the associated image
 *
 * @param     {Object} marketplaceEntity  The marketplace entity
 * @return    {string}                    Alt text
 */


exports.getDisclaimer = getDisclaimer;

var getImageAltText = function getImageAltText(marketplaceEntity) {
  return getName(marketplaceEntity);
};
/**
 * Get the source URL of the image associated with the offer.
 *
 * @param      {Object}  marketplaceEntity  The education loans entity
 * @return     {string}  The URL of the image.
 */


exports.getImageAltText = getImageAltText;

var getImageSrc = function getImageSrc(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.image_source.value');
};
/**
 * Get the issuer.
 *
 * @param {Object} marketplaceEntity The marketplace entity.
 *
 * @return {string} Issuer name.
 */


exports.getImageSrc = getImageSrc;

var getIssuerName = function getIssuerName(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getInstitution)(marketplaceEntity), 'name');
};
/**
 * Get the learn more link.
 *
 * @param {Object} marketplaceEntity The education loans entity.
 *
 * @return {string} Learn more link.
 */


exports.getIssuerName = getIssuerName;

var getLearnMoreLink = function getLearnMoreLink(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.review_link.value');
};
/**
 * Get the maximum fixed annual percentage rate (APR).
 *
 * @param {Object} marketplaceEntity The education loans entity.
 *
 * @return {number} The maximum fixed APR.
 */


exports.getLearnMoreLink = getLearnMoreLink;

var getMaxFixedAPR = function getMaxFixedAPR(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.max_fixed_apr.value');
};
/**
 * Get the maximum variable annual percentage rate (APR).
 *
 * @param {Object} marketplaceEntity The education loans entity.
 *
 * @return {number} The maximum variable APR.
 */


exports.getMaxFixedAPR = getMaxFixedAPR;

var getMaxVariableAPR = function getMaxVariableAPR(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.max_variable_apr.value');
};
/**
 * Get the minimum recommended FICO score.
 *
 * @param {Object} marketplaceEntity The education loans entity.
 *
 * @return {string} The minimum recommended FICO score.
 */


exports.getMaxVariableAPR = getMaxVariableAPR;

var getMinFICO = function getMinFICO(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.display_min_fico.value');
};
/**
 * Get the minimum fixed annual percentage rate (APR).
 *
 * @param {Object} marketplaceEntity The education loans entity.
 *
 * @return {number} The minimum fixed APR.
 */


exports.getMinFICO = getMinFICO;

var getMinFixedAPR = function getMinFixedAPR(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.min_fixed_apr.value');
};
/**
 * Get the minimum variable annual percentage rate (APR).
 *
 * @param {Object} marketplaceEntity The education loans entity.
 *
 * @return {number} The minimum variable APR.
 */


exports.getMinFixedAPR = getMinFixedAPR;

var getMinVariableAPR = function getMinVariableAPR(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.min_variable_apr.value');
};
/**
 * Get the name to display for an offer.
 *
 * @param      {Object}  marketplaceEntity  The education loans entity
 * @return     {string}  The offer name.
 */


exports.getMinVariableAPR = getMinVariableAPR;

var getName = function getName(marketplaceEntity) {
  return (0, _utils.getNameWithFallbacks)(marketplaceEntity);
};
/**
 * Gets the "pros" bullets
 *
 * @param  {Object} marketplaceEntity The marketplace entity
 *
 * @return {Array}  The "pros" array
 */


exports.getName = getName;

var getProsBullets = function getProsBullets(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.pros_bullets.value');
};
/**
 * Get the qualifications bullets.
 *
 * @param      {Object}  marketplaceEntity  The education loans entity
 * @return     {Array}   The qualifications.
 */


exports.getProsBullets = getProsBullets;

var getQualificationsBullets = function getQualificationsBullets(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.qualifications_bullets.value');
};
/**
 * Get the slug.
 *
 * @param {Object} marketplaceEntity The education loans entity.
 * @return {string} The slug.
 */


exports.getQualificationsBullets = getQualificationsBullets;

var getSlug = function getSlug(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getProduct)(marketplaceEntity), 'external_id');
};
/**
 * Get the star rating.
 *
 * @param      {Object}  marketplaceEntity  The education loans entity.
 * @return     {number}  The star rating.
 */


exports.getSlug = getSlug;

var getStarRating = function getStarRating(marketplaceEntity) {
  // Education loans store the star rating as a string,
  // but all libraries expect a number, so convert here
  var starRating = (0, _get2.default)(marketplaceEntity, 'product.details.star_rating.value');
  return starRating && parseFloat(starRating);
};
/**
 * Get the star rating tooltip.
 *
 * @return     {string}  The star rating tooltip.
 */


exports.getStarRating = getStarRating;

var getStarRatingTooltip = function getStarRatingTooltip() {
  return "NerdWallet's ratings are determined by our editorial team. The scoring formula for student loan products takes into account more than 50 data points across multiple categories, including repayment options, customer service, lender transparency, loan eligibility and underwriting criteria.";
};
/**
 * Get sub product type.
 *
 * @param {Object}  marketplaceEntity  The education loans entity.
 * @return {String}                    The sub product type.
 */


exports.getStarRatingTooltip = getStarRatingTooltip;

var getSubProductType = function getSubProductType(marketplaceEntity) {
  return (0, _get2.default)((0, _generalUtils.getProduct)(marketplaceEntity), 'details.type.value');
};
/**
 * Get the loan offer type classification.
 * @todo https://nerdwallet.atlassian.net/browse/SHOP-10043
 *
 * @param {Object}  marketplaceEntity  The education loans entity.
 * @return {String}                    The loan sub-type.
 */


exports.getSubProductType = getSubProductType;

var getOfferType = function getOfferType(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.type.value');
};
/**
 * Get annotation for fixed APR.
 *
 * @param {Object} marketplaceEntity  The education loans entity.
 * @return {String}                   The annotation for fixed APR
 */


exports.getOfferType = getOfferType;

var getFixedAprAnnotation = function getFixedAprAnnotation(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.fixed_apr_annotation.value');
};
/**
 * Get annotation for variable APR.
 *
 * @param {Object} marketplaceEntity  The education loans entity.
 * @return {String}                   The annotation for variable APR
 */


exports.getFixedAprAnnotation = getFixedAprAnnotation;

var getVariableAprAnnotation = function getVariableAprAnnotation(marketplaceEntity) {
  return (0, _get2.default)(marketplaceEntity, 'details.variable_apr_annotation.value');
};

exports.getVariableAprAnnotation = getVariableAprAnnotation;